import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logoFooter.png'


const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "footer__inner" }
const _hoisted_4 = { class: "footer__inner-col" }
const _hoisted_5 = { class: "footer__inner-col" }
const _hoisted_6 = { class: "footer__inner-col-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_SocialMedia = _resolveComponent("SocialMedia")!
  const _component_SubscriptionNews = _resolveComponent("SubscriptionNews")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "footer__inner-col" }, [
          _createElementVNode("img", {
            class: "symbol",
            src: _imports_0,
            alt: "Герб"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_ButtonComponent, {
            class: "mt-8",
            btnType: "news",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogWindow = !_ctx.dialogWindow)),
            title: "Подписка на новости"
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_SocialMedia)
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "footer__inner-col-block" }, [
            _createElementVNode("p", null, "Служба технической поддержки:"),
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                href: "mailto:supportved@economy.gov.ru",
                target: "_blank"
              }, "supportved@economy.gov.ru")
            ])
          ], -1))
        ])
      ]),
      _createVNode(_component_ModalComponent, {
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogWindow = false)),
        modelValue: _ctx.dialogWindow,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogWindow) = $event)),
        title: "Подписка на новости",
        width: 500
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SubscriptionNews, { onClose: _ctx.closeEditor }, null, 8, ["onClose"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}